import Vue from "vue";
import VueRouter from "vue-router";
// import store from "../store/index";

Vue.use(VueRouter);

//로그인페이지 입장 가드 (로그인 페이지입장 버튼 존재시 필요) 
//이미 로그인된 유저의 경우, 로그인 화면으로 못가고 홈화면으로 감
// const rejectAuthUser = (to, from, next) => {
//   if (store.state.isLogin === true) {
//     next("/");
//   } else {
//     next();
//   }
// };

// 로그인후 대쉬보드로 (각 페이지를 접속하기 전에 접속권한확인)
// 그외의 페이지는 토큰이 존재시 접속되고, 아니면 로그인 페이지로 이동
// 동기화 방식으로 실행: 페이지열람의 권한을 먼저 확인 필요
// async function checkAuthUser(to, from, next) {
//   if (store.state.isLogin == false) {
//     next("/Login");
//   } else {
//     if (to.name == "Dashboard") {          //첫 홈화면은 접속가능
//       // store.state.isDashboard = true;
//       next();
//     } else {                                //나머지 화면은 권한체크
//       // store.state.isDashboard = false;
//       var iRet = await store.state.iGetPromgramUserRoleInfo(getProgramNm(to.name), to.name, from.name);
//       if (iRet == 0) {
//         next();
//       } else if(iRet == -1) {
//         next("/NoPermission");
//       } else if(iRet == -2) {
//         store.state.isLogin = false;
//         store.state.isLoginError = false;
//         store.state.UserInfo.UserId = "";
//         store.state.UserInfo.UserNm = "";
//         next("/Login");
//       }
//     }
//   }
// }

// 각 페이지의 캡션이름 가져오기 (checkAuthUser에서 사용)
// function getProgramNm(name) {
//   for(var i =0; routes.length; i++){
//     if (routes[i].name == name) {
//       return routes[i].caption;
//     }
//   }
//   return "(알 수 없음)";
// }

//-----------------------------------------------------------------------------//
//페이지 추가시, DB의 programinfo table(CRUD)에 추가 필요

const routes = [
  {
    path: "/",
    name: "Dashboard",
    component: () => import("../views/Dashboard.vue")
  },
  {
    path: "/ko",
    name: "ko",
    component: () => import("../views/ko.vue")
  },
  {
    path: "/en",
    name: "en",
    component: () => import("../views/en.vue")
  },
];

// mode: "history",
const router = new VueRouter({
  mode: "hash",                    //기본설정은 hash모드임 (URL에 #포함. URL변경시 페이지가 다시 로드되지 않음.)
  base: process.env.BASE_URL,
  linkActiveClass: 'is-active',          //전역에 동일하게 CSS를 적용
  routes
});

export default router;